<template>
    <b-overlay
      id="overlay-background"
      class="overlay-config calendar-seasonal"
      :show="loading"
      rounded="sm"
    >
      <span
        :class="{
          'filter-kpi': true,
          hide: loading,
        }"
      >
        <label for="filter-kpi">Filtro: </label>
        <input type="text" name="filter-kpi" class="ml-1" v-model="filter" />
      </span>
      <b-list-group class="formatListGreatness">
        <b-list-group-item
          v-for="greatness of listGreatness"
          class="greatnessItem"
          :key="greatness"
          :id="keyValueGreatness[greatness]"
          @click="greatnessItemSelected"
          >{{ keyValueGreatness[greatness]}}</b-list-group-item
        >
      </b-list-group>
      <b-row class="groupBtn">
        <img
          src="@/assets/cancel.png"
          alt="remove"
          style="margin-left: 30px;"
          title="Remover Variável PL"
          @click="clear()"
        />
        <img
          src="@/assets/salvar.png"
          alt="salvar"
          style="margin-left: 30px;"
          title="Salvar Variável PL"
          @click="salvar()"
        />
        <img
          src="@/assets/sair.png"
          style="margin-left: 30px;"
          :title="$t('cancelar')"
          alt="cancelar"
          @click="$bvModal.hide('showListGreatness')"
        />
      </b-row>
    </b-overlay>
  </template>
  
  <script>
  import axios from "axios";
  import { urlMainAPI, defaultSuccess, showError } from "../../global";
  export default {
    name: "SelectGreatness",
    props: ["getItemSelected"],
    data() {
      return {
        listGreatnessBkp: [],
        listGreatness: [],
        keyValueGreatness: {},
        greatnessSelected: null,
        loading: false,
        filter: "",
      };
    },
  
    watch: {
      filter() {
        if (!this.filter)
          this.listGreatness = JSON.parse(
            JSON.stringify(this.listGreatnessBkp)
          );
        else
          this.listGreatness = this.listGreatnessBkp.filter((p) => 
            this.keyValueGreatness[p].toLocaleLowerCase().includes(this.filter.toLocaleLowerCase())
          );
      },
    },
  
    methods: {
      async getListGreatness() {
        this.loading = true;
        const url = `${urlMainAPI}/getlistgreatness`;
        await axios
          .get(url)
          .then((res) => {
            if(res.status == 200){
              this.keyValueGreatness = res.data;
              this.listGreatness =  Object.keys(res.data);
              this.listGreatnessBkp = JSON.parse(
                JSON.stringify(this.listGreatness)
                );
                setTimeout(() => {
                  this.loadGreatnessSelected();
                }, 100);
            }
          }).catch((e) => {
            console.log(e);
            this.wait = false;
          });
        this.loading = false;
      },
  
      greatnessItemSelected(event) {
        document
          .querySelectorAll(".greatnessItem")
          .forEach((e) => e.classList.remove("active"));
        event.target.classList.add("active");
        this.greatnessSelected = event.target.id;
      },
  
      loadGreatnessSelected() {
        document
          .querySelectorAll(".greatnessItem")
          .forEach((e) => e.classList.remove("active"));
        this.greatnessSelected = this.getItemSelected;
        
        let el = document.getElementById(`${this.greatnessSelected}`);
        if (el) {
          el.classList.add("active");
        } else if (this.greatnessSelected) {
          showError(this.$t('grandeza-nao-encontrada'));
        }
      },
  
      salvar() {
        this.$emit("greatnessSelected", this.greatnessSelected);
        this.$bvModal.hide("showListGreatness");
        defaultSuccess(this.$t('grandeza-atribuida-com-sucesso'));
      },

      clear(){
        this.$emit("greatnessSelected", "");
        this.$bvModal.hide("showListGreatness");
        defaultSuccess("Grandeza removida!");
      },
    },
    mounted() {
      this.getListGreatness();
    },
  };
  </script>
  
  <style scoped>
  .formatListGreatness {
    height: 50vh;
    overflow-y: auto;
  }
  
  .greatnessItem {
    cursor: pointer;
  }
  
  .list-group-item.active {
    cursor: pointer;
    background-color: rgb(142, 210, 210);
    color: black;
    border: none;
  }
  
  .groupBtn {
    margin-left: 16px;
    margin-right: 16px;
  }
  
  .filter-kpi > input {
    border: 2px solid black;
    border-radius: 4px;
  }
  </style>
  